import { Auditable, QueryParams, SortParams } from "..";

export interface ShippingStatus extends Auditable {
    name: string;
}

export const DefaultShippingStatusQueryParams: QueryParams = {
    name: "",
};

export const DefaultShippingStatusSortParams: SortParams = {
    orderBy: "name",
    orderDesc: "false",
};
